import classNames from 'classnames'
import React from 'react'
import { Icon } from '@blueprintjs/core'

interface StepsProps {
    identificationNumberType: string
    step: number
}

export const Steps = ({ step, identificationNumberType }: StepsProps) => {
    const steps = [
        { name: 'Seller Type' },
        { name: identificationNumberType + 's' },
        { name: 'Campaigns' },
        { name: 'Ad Groups' },
        { name: 'Portfolios' },
        { name: 'Upload' },
    ]

    return (
        <div>
            <div className="flex justify-around mb-8">
                {steps.map((s, i) => (
                    <div key={i} className="flex-grow flex flex-col items-center">
                        <div className="relative w-full flex flex-col items-center">
                            <Icon
                                icon="full-circle"
                                color={
                                    step > i + 1 ? '#6EE7B7' : step < i + 1 ? '#D1D5DB' : '#6366F1'
                                }
                                size={20}
                            />
                            <div
                                className={classNames('absolute top-2 w-full h-1', {
                                    'bg-green-300': step > i + 1,
                                    'bg-indigo-500': step === i + 1,
                                    'bg-gray-300': step < i + 1,
                                })}
                            />
                        </div>
                        <div
                            className={classNames('mt-3 text-lg', {
                                'font-normal text-indigo-500': step === i + 1,
                                'text-gray-300': step !== i + 1,
                            })}
                        >
                            {s.name}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
